import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function TermsOfService() {
  return (
    <StaticPage title="Terms of Service" subtitle="Please read these terms carefully before using RentalX.">
      <p className="text-sm text-gray-500 mb-8">Last updated: February 2026</p>

      <Section title="1. Acceptance of Terms">
        <p>By accessing or using RentalX ("the Platform"), you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, please do not use the Platform. These terms apply to all users including students, landlords, and visitors.</p>
      </Section>

      <Section title="2. Eligibility">
        <p>You must be at least 18 years old to create an account on RentalX. By registering, you confirm that the information you provide is accurate and that you are legally permitted to enter into this agreement.</p>
      </Section>

      <Section title="3. User Accounts">
        <ul className="list-disc list-inside space-y-1">
          <li>You are responsible for maintaining the security of your account and password</li>
          <li>You must notify us immediately of any unauthorised use of your account</li>
          <li>You may not share your account credentials with others</li>
          <li>We reserve the right to suspend or terminate accounts that violate these terms</li>
        </ul>
      </Section>

      <Section title="4. Landlord Obligations">
        <ul className="list-disc list-inside space-y-1">
          <li>All listings must accurately represent the property</li>
          <li>Landlords must comply with all applicable state and federal tenancy laws</li>
          <li>Misrepresentation of listings is grounds for immediate account termination</li>
          <li>Landlords are solely responsible for the accuracy of their listings and the conduct of tenancies</li>
        </ul>
      </Section>

      <Section title="5. Student Obligations">
        <ul className="list-disc list-inside space-y-1">
          <li>Students must provide accurate information when making enquiries</li>
          <li>Students are responsible for conducting their own due diligence before signing a lease</li>
          <li>RentalX is a listing platform and is not a party to any tenancy agreement</li>
        </ul>
      </Section>

      <Section title="6. Prohibited Uses">
        <ul className="list-disc list-inside space-y-1">
          <li>Posting false, misleading, or fraudulent listings</li>
          <li>Discriminating against users based on protected characteristics</li>
          <li>Scraping, harvesting, or automated access to the platform without our written permission</li>
          <li>Attempting to gain unauthorised access to any part of the platform</li>
          <li>Using the platform for any unlawful purpose</li>
        </ul>
      </Section>

      <Section title="7. Limitation of Liability">
        <p>RentalX is a marketplace platform and does not own, manage, or control any listed properties. We are not liable for any losses arising from tenancy agreements, property conditions, or interactions between users. To the maximum extent permitted by Australian law, our liability is limited to the amount you paid us in the 12 months preceding the claim.</p>
      </Section>

      <Section title="8. Governing Law">
        <p>These Terms are governed by the laws of Victoria, Australia. Any disputes will be subject to the exclusive jurisdiction of the courts of Victoria.</p>
      </Section>

      <Section title="9. Contact">
        <p>For questions about these Terms: <strong>legal@rentalx.com.au</strong></p>
      </Section>
    </StaticPage>
  );
}
